import { Dropdown } from "../../Components/Form/Dropdown";

let min = document.querySelector<Dropdown>('[name="filter.v.price.gte"]');
let max = document.querySelector<Dropdown>('[name="filter.v.price.lte"]');

const handleChange = () => {
    if (min.value && max.value && min.selectedIndex > max.selectedIndex) {
        const tmp = max.selectedIndex;
        max.selectedIndex = min.selectedIndex - 1;
        min.selectedIndex = tmp + 1;
    }
};

export const destroyPriceRangeFilter = () => {
    min.removeEventListener("change", handleChange);
    max.removeEventListener("change", handleChange);
};

const attachListeners = () => {
    min.addEventListener("change", handleChange);
    max.addEventListener("change", handleChange);
};

export const initPriceRangeFilter = (minSelect: Dropdown, maxSelect: Dropdown) => {
    min = minSelect;
    max = maxSelect;
    attachListeners();
};

if (min && max) {
    attachListeners();
}
